import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  "NAME": (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const changePassDuck = createDuck("CHANGE_PASS", newActions, newReducers);

const changePassThunk = (data) => {
  const url = `${baseUrl}/editPassword`;
  return createThunk(axios, "post", changePassDuck.actions, url, data);
};

export default {
  changePassDuck,
  changePassThunk,
};
